import { render, staticRenderFns } from "./BaseButtonShiftPrint.vue?vue&type=template&id=827bedd0&scoped=true&"
import script from "./BaseButtonShiftPrint.vue?vue&type=script&lang=js&"
export * from "./BaseButtonShiftPrint.vue?vue&type=script&lang=js&"
import style0 from "./BaseButtonShiftPrint.vue?vue&type=style&index=0&id=827bedd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "827bedd0",
  null
  
)

export default component.exports